.toolbar {
	background-color: var(--rx-primary-red);
	height: 64px;
	display: flex;
}
.userContainerRight {
	vertical-align: middle !important;
	line-height: 64px !important;
	font-size: 0.9rem !important;
}

.rightContainer {
	width: 100%;
	display: flex;
	position: relative;
	flex-direction: row;
	justify-content: flex-end;
}

.topbarLogo {
	object-fit: scale-down;
	width: fit-content;
	height: 50px;
	font-size: 50px;
	margin-top: 5px !important;
	cursor: pointer !important;
}

.cart {
	cursor: pointer !important;
	width: fit-content;
	height: 45px !important;
	width: 45px !important;
	margin-top: 5px !important;
}

.zeroPadding {
	padding: 0 !important;
}

.userEmailInfo {
	background-color: var(--light-gray);
	pointer-events: none;
	cursor: default;
}

.seperator {
	pointer-events: none;
	cursor: default;
}

@media (max-width: 600px) {
	.toolbar {
		height: 128px;
		display: flex;
	}

	.topbarLogo {
		object-fit: scale-down;
		width: fit-content;
		height: 40px !important;
		font-size: 40px !important;
		margin-top: 5px !important;
		cursor: pointer !important;
	}

	.userContainerRight {
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
		vertical-align: middle !important;
		line-height: 0.5rem !important;
		font-size: 0.9rem !important;
	}

	.userEmailInfo {
		min-height: 30px !important;
		max-height: 30px !important;
	}

	.seperator {
		min-height: 20px !important;
		max-height: 20px !important;
	}

	.menuItem {
		min-height: 35px !important;
		max-height: 35px !important;
	}
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
	.toolbar {
		height: 128px;
		display: flex;
	}

	.topbarLogo {
		object-fit: scale-down;
		width: fit-content;
		height: 40px !important;
		font-size: 40px !important;
		margin-top: 5px !important;
		cursor: pointer !important;
	}

	.userContainerRight {
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
		vertical-align: middle !important;
		line-height: 0.5rem !important;
		font-size: 0.9rem !important;
	}

	.userEmailInfo {
		min-height: 30px !important;
		max-height: 30px !important;
	}

	.seperator {
		min-height: 20px !important;
		max-height: 20px !important;
	}

	.menuItem {
		min-height: 35px !important;
		max-height: 35px !important;
	}
}
